import React, { useContext } from 'react';
import Content from '../components/content/Content';
import Footer from '../components/footer/Footer';
import AppMenu from '../components/app-menu/AppMenu';
import './App.css';
import AppContainer from '../components/app-container/AppContainer';
import { ThemeProvider, createTheme } from '@mui/material/styles';
import CssBaseline from '@mui/material/CssBaseline';
import ThemeOptionContext from '../context/theme-option/ThemeOptionContext';
import { HashRouter } from 'react-router-dom';
import { ptBR } from '@mui/material/locale';
import { ptBR as ptBRDate } from '@mui/x-date-pickers';

function App() {
  const { state: themeState } = useContext(ThemeOptionContext);

  const theme = React.useMemo(() => {
    return createTheme(
      {
        palette: {
          mode: themeState.isDark ? 'dark' : 'light',
          secondary: { main: '#424242' },
        },
      },
      ptBR,
      ptBRDate,
    );
  }, [themeState.isDark]);

  return (
    <HashRouter>
      <ThemeProvider theme={theme}>
        <CssBaseline />
        <AppContainer>
          <AppMenu />
          <Content />
          <Footer />
        </AppContainer>
      </ThemeProvider>
    </HashRouter>
  );
}

export default App;
